import { createApp } from 'vue';
import TestimonialsCarousel from './components/TestimonialsCarousel.vue';

// Initialize Vue app when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
	const appElement = document.getElementById('testimonials-carousel-app');

	if (appElement) {
		const testimonialsData = appElement.dataset.testimonials || '[]';

		const testimonials = JSON.parse(testimonialsData);

		if (testimonials.length > 0) {
			const app = createApp(TestimonialsCarousel, {
				testimonials,
			});

			app.mount('#testimonials-carousel-app');
		}
	}
});
